import moment from "moment";

export const useMilestoneHandlers = ({
  milestone,
  id,
  description,
  name,
  error,
  epics,
  updateCardMutate,
  checkpointMutate,
  deleteMutate,
  setName,
  setErrorText,
  setError,
}) => {
  const handleDescription = () => {
    updateCardMutate({
      epic_id: milestone,
      board_id: id,
      data: { description },
    });
  };

  const handleStartdate = (newValue) => {
    updateCardMutate({
      epic_id: milestone,
      board_id: id,
      data: {
        start_date: newValue?.$d ? moment(newValue.$d).format("YYYY-MM-DD") : "",
      },
    });
  };

  const handleTargetdate = (newValue) => {
    updateCardMutate({
      epic_id: milestone,
      board_id: id,
      data: {
        target_release_date: newValue?.$d ? moment(newValue.$d).format("YYYY-MM-DD") : "",
      },
    });
  };

  const handleCheckBox = (event, value, checkpointId) => {
    checkpointMutate({
      checkpoint_id: checkpointId,
      data: { is_done: value },
    });
  };

  const handleDelete = () => {
    deleteMutate({ milestone, id });
  };

  const handleComplete = () => {
    updateCardMutate({
      epic_id: milestone,
      board_id: id,
      data: {
        completed: !epics?.data?.data.responseData.epic.completed,
      },
    });
  };

  const handleCheckName = (e, checkpointId) => {
    if (e.key === "Enter") {
      checkpointMutate({
        checkpoint_id: checkpointId,
        data: { checkpoint_name: e.target.value },
      });
    }
  };

  const handleNameChange = (value, errorMsg, hasError) => {
    setName(value);
    setErrorText(errorMsg);
    setError(hasError);
  };

  const handleNameKeyDown = (e) => {
    if (!error && (e.key === "Enter" || e.type === "blur")) {
      updateCardMutate({
        epic_id: milestone,
        board_id: id,
        data: { epic_name: name },
      });
    }
  };

  return {
    handleDescription,
    handleStartdate,
    handleTargetdate,
    handleCheckBox,
    handleDelete,
    handleComplete,
    handleCheckName,
    handleNameChange,
    handleNameKeyDown,
  };
}; 